<template>
    <div class="pages">
        <!-- 快捷栏 -->
        <shortcut-bar class="shortcut-bar page-header" />
        <div class="page-header-placeholder"></div>

        <div class="box">
            <div class="boxBreadcrumb">
                <el-breadcrumb separator-class="el-icon-arrow-right">
                    <el-breadcrumb-item :to="{ path: '/' }">{{ $t('首页') }}</el-breadcrumb-item>
                    <el-breadcrumb-item :to="{ path: '/user-center/0/my-order2' }">{{ $t('我的订单') }}</el-breadcrumb-item>
                    <el-breadcrumb-item>{{ $t('订单详情') }}</el-breadcrumb-item>
                </el-breadcrumb>
            </div>

            <div class="box-box" :class="{ 'is-h5': isH5 }">
                <div class="form-row align-center margin-bottom-20">
                    <div class="box-tit box-tit-box">{{ $t('退款商品') }}</div>
                    <div class="form-row-content">
                        <div class="box-xinxi text-14 box-xinxi-wrap">
                            <img :src="tableData.product_image" alt="" class="xinxi-img">
                            <div class="justify-between flex-direction box-xinxi-content">
                                <div>
                                    <div class="margin-bottom-8">{{ tableData.product_title }}</div>
                                    <div class="text-999">{{ tableData.product_sku_text }}</div>
                                </div>
                                <div class="text-22 text-85674B">￥{{ tableData.product_price }}</div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="form-row align-center margin-bottom-20">
                    <div class="box-tit box-tit-box">{{ $t('售后类型') }}</div>
                    <div class="form-row-content">{{ type == 'refund' ? $t('仅退款') : $t('退货退款') }}</div>
                </div>

                <!-- <div class="align-center margin-bottom-20">
                    <div class="box-tit">货物状态</div>
                    <el-radio v-model="radio" label="1">未收到货</el-radio>
                    <el-radio v-model="radio" label="2">已收到货</el-radio>
                </div> -->

                <div class="form-row align-center margin-bottom-24">
                    <div class="box-tit"><span class="text-fd3b00">*</span>{{ $t('退款原因') }}</div>
                    <el-select v-model="reason" :placeholder="$t('请选择')" class="box-select">
                        <el-option v-for="(item, index) in options" :key="index" :value="item.reason"></el-option>
                    </el-select>
                </div>

                <div class="form-row align-center margin-bottom-24">
                    <div class="box-tit"><span class="text-fd3b00">*</span>{{ $t('退款金额') }}</div>
                    <div class="box-txt">{{ tableData.product_price }}</div>
                    <!-- <el-input type="number" v-model="refundAmount" placeholder="请输入" style="width: 480px;"
                        :disabled="true"></el-input> -->
                </div>

                <div class="form-row align-center margin-bottom-24">
                    <div class="box-tit box-tit-box"><span class="text-fd3b00">*</span>{{ $t('退款说明') }}</div>
                    <textarea placeholder="请输入..." v-model="content" class="box-textarea"></textarea>
                </div>

                <div class="form-row align-center margin-bottom-24">
                    <div class="box-tit box-tit-box">{{ $t('上传照片') }}</div>
                    <div class="box-upload">
                        <el-upload :action="$BASE_URL + '/api/v1/64803624da6de'" :headers="headers" :limit="9"
                            list-type="picture-card" :on-remove="handleRemove" :on-success="handleAvatarSuccess">
                            <i class="el-icon-plus"></i>
                        </el-upload>
                        <div class="box-upload-txt">{{ $t('上传凭证最多9张') }}</div>
                    </div>
                </div>

                <div class="box-btn" v-if="!isH5" @click="onSubmit">{{ $t('提交') }}</div>

                <div class="order-step-wrap">
                    <ShoppingProcess :list="stepList" :indexValue="indexValue" />
                </div>

            </div>
        </div>

        <div class="h5-action-bar" v-if="isH5">
            <div class="h5-btn h5-btn-primary" @click="onSubmit">{{ $t('提交') }}</div>
        </div>

        <footer-bar></footer-bar>
    </div>
</template>

<script>
import ShortcutBar from '@/components/ShortcutBar'
import ShoppingProcess from '../order/components/ShoppingProcess.vue';
// ./components/step.vue
// import { myOrderDetail, afterSaleType, refundCause, applyForRefund } from '@/api/user'
import { getToken } from "@/utils/auth";
import { orderDetail, refundCause, refundApply } from '@/api/user';
import footerBar from '@/components/footerBar';

export default {
    name: 'UserCenter',
    components: {
        'shortcut-bar': ShortcutBar,
        'footer-bar': footerBar,
        ShoppingProcess,
    },
    data() {
        return {
            id: '',//订单id
            type: '',//退款方式
            tableData: {},//订单商品
            radio: '1',//货物状态
            after_sale_type: [],//售后类型
            options: [],//退款原因
            reason: '',//选中的退款原因
            refundAmount: '',//退款金额
            content: '',//退款说明
            headers: {},//图片上传的请求头
            orderItemId: '',//订单商品id
            images: [],//图片
            stepList: [{
                txt: this.$t('买家申请退款'),
                value: '1'
            }, {
                txt: this.$t('商家处理退款申请'),
                value: '2'
            }, {
                txt: this.$t('售后结果'),
                value: '3'
            }],//步骤条
            indexValue: '0',//步骤条位置
            isH5: typeof window !== 'undefined' && window.innerWidth < 768,
        }
    },
    computed: {

    },
    mounted() {
        this.updateIsH5();
        window.addEventListener('resize', this.updateIsH5);
        // this.id = this.$route.params.id;
        this.tableData = JSON.parse(decodeURIComponent(this.$route.params.order))
        console.log(this.tableData);
        this.type = this.$route.params.type;
        // this.onOrderDetail()
        this.onRefundCause()

        // this.onDetail()
        this.headers = {
            'user-token': getToken()
        }
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.updateIsH5);
    },
    methods: {
        updateIsH5() {
            this.isH5 = window.innerWidth < 768;
        },
        /**提交 */
        onSubmit() {
            if (!this.reason) {
                this.$message.warning(this.$t('请选择退款原因'));
                return
            }
            if (!this.content.trim()) {
                this.$message.warning(this.$t('请输入退款说明'));
                return
            }
            let images = this.images.join(',')
            // let order_item_id = []
            // let list = this.items
            // list.forEach(item => {
            //     order_item_id.push(item.id)
            // })

            let data = {
                type: this.type,
                reason: this.reason,
                content: this.content,
                images: images,
                order_id: this.tableData.order_id,
                order_item_id: this.tableData.id,
            }
            console.log(data);
            // return
            refundApply(data).then(res => {
                if (res.code == 1) {
                    this.$message.success(this.$t('已提交申请'));
                    setTimeout(ress => {
                        this.$router.push({ name: 'MyOrder2', params: { type: 0 } });
                    }, 1000)
                } else {
                    this.$message.warning(res.msg);
                }
            })
        },
        /**图片上传 */
        handleAvatarSuccess(res, file, fileList) {
            this.images = []
            fileList.forEach(item => {
                this.images.push(item.response.data.url)
            })
        },
        /**图片移除 */
        handleRemove(file, fileList) {
            // console.log(file.response.data.url, fileList);
            this.images = []
            fileList.forEach(item => {
                this.images.push(item.response.data.url)
            })
        },
        /**退款原因 */
        onRefundCause() {
            refundCause({ type: 'refund' }).then(res => {
                this.options = res.data
                // console.log(this.options);
            })
        },
        /**订单详情 */
        onOrderDetail() {
            orderDetail({ id: this.id }).then(res => {
                let data = res.data
                this.items = data.items
                // console.log(data);
                let list = data.items
                let refundAmount = 0
                list.forEach(e => {
                    refundAmount = refundAmount + Number(e.product_price)
                })
                this.refundAmount = refundAmount.toFixed(2)
            })
        },
    }
};
</script>

<style scoped lang="scss">
@mixin pc-scrollbar {
    scrollbar-width: thin;
    scrollbar-color: #333333 #ececec;

    &::-webkit-scrollbar {
        height: 6px;
        width: 6px;
    }

    &::-webkit-scrollbar-track {
        background: #ececec;
        border-radius: 4px;
    }

    &::-webkit-scrollbar-thumb {
        background: #333333;
        border-radius: 4px;

        &:hover {
            background: #000000;
        }
    }
}

.page-header {
    z-index: 999;
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
}

.page-header-placeholder {
    height: 56px;
}

.box {
    padding: 0 var(--page-gutter-wide);
}

/*面包屑*/
.boxBreadcrumb {
    padding: 24px 0 32px 0;
}

/**订单内容 */
.box-box {
    /* // padding: 32px; */
    background: #FFFFFF;
    border-radius: 8px;
    /* // height: calc(100vh - 200px); */
    overflow: auto;
    box-shadow: 0px 3px 16px 0px rgba(0, 0, 0, 0.2);
    padding: 32px 24px;
    margin-bottom: 80px;

    .box-tit {
        font-size: 16px;
        color: #999999;
        margin-right: 24px;
    }

    .box-tit-box {
        margin-left: 4px;
    }

    .box-select {
        width: 480px;
    }

    .box-txt {
        width: 480px;
        height: 38px;
        line-height: 38px;
        border: 1px solid #DCDFE6;
        border-radius: 4px;
        padding-left: 15px;
        font-size: 14px;
        box-sizing: border-box;
    }

    .box-textarea {
        padding: 8px 15px;
        font-size: 14px;
        width: 480px;
        height: 95px;
        resize: none;
        background: #FFFFFF;
        border-radius: 4px 4px 4px 4px;
        border: 1px solid #DCDFE6;
        box-sizing: border-box;
    }

  /**商品 */
    .box-xinxi-wrap {
        width: 560px;
    }

    .box-xinxi-content {
        width: calc(100% - 136px);
    }

    .box-xinxi {
        display: flex;
        margin-bottom: 12px;

        .xinxi-img {
            width: 120px;
            height: 120px;
            border-radius: 8px;
            margin-right: 16px;
            object-fit: cover;
            object-position: center;
            flex-shrink: 0;
        }
    }

    .box-xinxi:last-child {
        margin-bottom: 0;
    }

    .box-upload-txt {
        font-size: 16px;
        color: #999999;
        margin-top: 12px;
    }

    .order-step-wrap {
        margin-top: 32px;
        overflow-x: auto;
        overflow-y: hidden;
        -webkit-overflow-scrolling: touch;
        padding-bottom: 4px;
        @include pc-scrollbar;
    }

    .box-btn {
        width: 160px;
        height: 42px;
        background: #000000;
        border-radius: 8px;
        font-size: 16px;
        color: #FFFFFF;
        font-weight: bold;
        text-align: center;
        line-height: 42px;
        margin-left: calc(120px - 32px);
        /* // margin: 32px auto 0; */
        cursor: pointer;
    }
}

@media (max-width: 767px) {
    .pages {
        overflow-x: hidden;
        width: 100%;
        background: #f5f6f8;
        padding-bottom: calc(72px + env(safe-area-inset-bottom, 0px));
    }

    .page-header {
        padding-top: env(safe-area-inset-top, 0px);
    }

    .page-header-placeholder {
        height: calc(56px + env(safe-area-inset-top, 0px));
    }

    .box {
        padding: 0 12px 24px;
        box-sizing: border-box;
    }

    .boxBreadcrumb {
        padding: 10px 0 12px;
        overflow-x: auto;
        white-space: nowrap;
        font-size: 12px;
    }

    .box-box.is-h5 {
        background: transparent;
        border-radius: 0;
        box-shadow: none;
        padding: 0;
        margin-bottom: 0;
        overflow: visible;
        display: flex;
        flex-direction: column;
        gap: 12px;

        .form-row {
            flex-direction: column;
            align-items: stretch;
            margin-bottom: 0;
            background: #fff;
            border-radius: 8px;
            padding: 12px;
            box-shadow: 0 2px 10px rgba(0, 0, 0, 0.06);
            box-sizing: border-box;
        }

        .box-tit {
            margin-right: 0;
            margin-bottom: 10px;
            font-size: 14px;
            color: #666;
        }

        .box-tit-box {
            margin-left: 0;
        }

        .form-row-content {
            width: 100%;
        }

        .box-select {
            width: 100%;
        }

        /deep/ .box-select .el-input {
            width: 100%;
        }

        .box-txt {
            width: 100%;
        }

        .box-textarea {
            width: 100%;
            height: 88px;
        }

        .box-xinxi-wrap {
            width: 100%;
        }

        .box-xinxi-content {
            width: calc(100% - 92px);
            min-width: 0;
        }

        .box-xinxi {
            margin-bottom: 0;

            .xinxi-img {
                width: 80px;
                height: 80px;
                flex-shrink: 0;
                object-fit: cover;
                margin-right: 12px;
            }

            .text-22 {
                font-size: 18px;
            }
        }

        .box-upload-txt {
            font-size: 13px;
            margin-top: 8px;
        }

        .order-step-wrap {
            margin-top: 0;
            background: #fff;
            border-radius: 8px;
            padding: 12px 8px;
            box-shadow: 0 2px 10px rgba(0, 0, 0, 0.06);
            overflow-x: auto;
            overflow-y: hidden;
            -webkit-overflow-scrolling: touch;
            scrollbar-width: none;
            -ms-overflow-style: none;

            &::-webkit-scrollbar {
                display: none;
            }
        }

        /deep/ .order-step-wrap .step {
            min-width: fit-content;
        }

        /deep/ .order-step-wrap .step .step-list .list-box {
            font-size: 12px;
        }
    }

    .h5-action-bar {
        position: fixed;
        left: 0;
        right: 0;
        bottom: 0;
        z-index: 998;
        display: flex;
        align-items: center;
        padding: 12px 16px calc(12px + env(safe-area-inset-bottom, 0px));
        background: #fff;
        box-shadow: 0 -2px 12px rgba(0, 0, 0, 0.08);
        box-sizing: border-box;

        .h5-btn {
            flex: 1;
            height: 44px;
            line-height: 44px;
            border-radius: 8px;
            font-size: 15px;
            text-align: center;
            cursor: pointer;
            box-sizing: border-box;
            transition: transform 0.15s ease, opacity 0.15s ease;
        }

        .h5-btn:active {
            transform: scale(0.98);
            opacity: 0.88;
        }

        .h5-btn-primary {
            background: #000;
            color: #fff;
            border: none;
        }
    }
}
</style>

<style>
.box-upload .el-upload--picture-card {
    width: 80px;
    height: 80px;
    line-height: 92px;
}

.box-upload .el-upload-list__item {
    width: 80px;
    height: 80px;
    line-height: 92px;
}
</style>



// WEBPACK FOOTER //
// src/view/afterSale/Refund.vue